import {
    FETCH_ORDENES,
    FETCH_ORDENES_EN_VERDE,
    FETCH_ORDEN,
    EDIT_ORDEN,
    FETCH_CLIENTE,
    LOADING_ORDENES,
    SET_FILTRO_ORDENES,
    FETCH_ORDENES_TELEFONICAS
} from '../actions/types';

const initialState = {
    loadingOrdenes: false,
    orden: {},
    ordenes: [],
    ordenesEnVerde: [],
    cliente: {},
    filtro: {}
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_FILTRO_ORDENES:
            return {
                ...state,
                filtro: action.payload
            };
        case FETCH_ORDENES:
            return {
                ...state,
                ordenes: action.payload
            };
        case FETCH_ORDENES_EN_VERDE:
            return {
                ...state,
                ordenesEnVerde: action.payload
            };
        case FETCH_ORDENES_TELEFONICAS:
            return {
                ...state,
                ordenesTelefonicas: action.payload
            };
        case LOADING_ORDENES:
            return {
                ...state,
                loadingOrdenes: action.payload
            };
        case FETCH_ORDEN:
            return {
                ...state,
                orden: action.payload
            };
        case EDIT_ORDEN:
            return {
                ...state,
                orden: action.payload
            };
        case FETCH_CLIENTE:
            return {
                ...state,
                cliente: action.payload
            };
        default: return state;
    }
}